<template>
  <div>
    <div class="footer-container">
      <div>
        <div class="title">About Us</div>
        <div class="about-us-block">
          Life Style Developers is one of the leading player in real estate and
          development industry, with an aim of delivering dream homes to our
          customers as a reliable partner.
        </div>
      </div>
      <div>
        <div class="title">Contact</div>
        <div>
          Tulsi apartment, opposite to Morya hospital, 9th lane, Rajarampuri,
          Kolhapur
        </div>
        <div>Lifestyledevelopers.kop@gmail.com</div>
        <div>+91 9822840096 <br />+91 8237629111</div>
      </div>
      <div>
        <div class="title">Links</div>
        <div class="links-container">
          <div>
            <div class="links">
              <a>
                <router-link to="/">Home</router-link>
              </a>
            </div>
            <div class="links">
              <a>
                <router-link to="/about-us">About Us</router-link>
              </a>
            </div>
            <div class="links">
              <a>
                <router-link to="/contact-us">Contact</router-link>
              </a>
            </div>
          </div>
          <div>
            <div class="links">
              <a>
                <router-link to="/testimonials">Testimonials</router-link>
              </a>
            </div>
            <div class="links">
              <a>
                <router-link to="/projects">Projects</router-link>
              </a>
            </div>
            <div class="links">
              <a>
                <router-link to="/consultancy">Consultancy</router-link>
              </a>
            </div>
          </div>
        </div>
        <div class="icon-container">
          <div>
            <img
              src="../assets/icons/footer/facebook.png"
              alt="facebook logo"
              class="icon"
              @click="facebookRedirect()"
            />
          </div>
          <div>
            <img
              src="../assets/icons/footer/instagram.png"
              alt="instagram logo"
              class="icon"
            />
          </div>
          <div @click="whatsappOnClick">
            <img
              src="../assets/icons/footer/whatsapp.png"
              alt="whatsapp logo"
              class="icon"
            />
          </div>
          <div @click="mailTO">
            <img
              src="../assets/icons/footer/email.png"
              alt="email logo"
              class="icon"
            />
          </div>
        </div>
      </div>
    </div>
    <div @click="expandbeeRedirect" class="credits">Made with 💗 By ExpandBee</div>
  </div>
</template>

<script>
export default {
  methods: {
    mailTO: function() {
      window.open("mailto:Lifestyledevelopers.kop@gmail.com");
    },
    whatsappOnClick: function() {
      window.open("https://wa.me/918237629111");
    },
    facebookRedirect: function() {
      window.open(
        "https://www.facebook.com/LifeStyle-Developers-107272987758011"
      );
    },
    expandbeeRedirect: function() {
      window.open(
        "https://www.expandbee.com"
      );
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap");

.credits {
  background: #222831;
  color: white;
  text-align: center;
  padding-bottom: 20px;
  font-size: 1rem;
  cursor: pointer;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Poppins";
  /* background-color: black;
        border: 1px solid red; */
  font-size: 0.8rem;
}

.footer-container {
  /* height: 25vh; */
  background-color: #222831;
  /* background-color: #eeeeee; */
  display: flex;
  flex-wrap: wrap;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 2vh;
  padding-bottom: 5vh;
}

.about-us-block {
  padding: 0 30px 0 0;
}
.footer-container > div {
  height: 100%;
  flex-grow: 1;
  flex-basis: 0;
  color: rgb(255, 255, 255);
  font-weight: 300;
  font-size: 0.9rem;
  line-height: 2rem;
}

.title {
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 3rem;
}

.links-container {
  display: flex;
}

.links-container > div {
  flex-grow: 1;
  flex-basis: 0;
  font-weight: 300;
  line-height: 2rem;
}

.icon-container {
  margin-top: 1rem;
  display: flex;
}

.icon-container > div {
  flex-grow: 1;
  flex-basis: 0;
}

.icon {
  /* display: inline-block; */
  /* width: 50px; */
  height: 40px;
  width: 40px;
  cursor: pointer;
}

.links {
  cursor: pointer;
}

.links a {
  text-decoration: none;
  color: white;
}

@media screen and (max-width: 500px) {
  .footer-container {
    flex-direction: column;
  }
}
</style>
